export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.customer-intelligence': 'Customer Intelligence',
  'menu.customer-intelligence.customer-list': 'Customer List',
  'menu.customer-intelligence.customer-detail': 'Customer Detail',
  'menu.settings': 'System Settings',
  'menu.solution-advancement': 'Solution Advancement',
  'menu.solution-advancement.detail': 'Advancement Detail',
  'menu.field-research': 'Field Research',
  'menu.field-research.records': 'Execution Records',
  'menu.field-research.panel': 'Execution Panel',
  'menu.settings.code-rules': 'Code Rules',
  'menu.settings.dict': 'Dictionary',
  'menu.settings.tag-pool': 'Tag Management',
  'menu.zy-consultant-operations': 'Question Bank',
  'menu.zy-consultant-operations.question-bank': 'Question List',
  'menu.zy-consultant-operations.question-bank.detail': 'Question Detail',
  'menu.zy-consultant-operations.question-packs': 'Question Packs',
  'menu.zy-consultant-operations.question-packs.detail': 'Pack Detail',
  'menu.zy-consultant-operations.diagnosis-sessions': 'Diagnosis Sessions',
  'menu.zy-consultant-operations.diagnosis-sessions.detail':
    'Diagnosis Session Detail',
  'menu.zy-consultant-operations.diagnosis-sessions.run': 'Run Diagnosis',
  'menu.zy-consultant-operations.diagnosis-sessions.result': 'Diagnosis Result',
  'menu.methodology-center': 'Methodology Center',
  'menu.methodology-center.industry-cases': 'Industry Cases',
  'menu.methodology-center.common-pain-points': 'Common Pain Points',
  'menu.methodology-center.solution-playbooks': 'Solution Playbooks',
  'menu.methodology-center.pilot-scenes': 'Pilot Scenes',
  'menu.methodology-center.talk-tracks': 'Talk Tracks',
  'menu.methodology-center.failure-reasons': 'Failure Reasons',
  'menu.methodology-center.success-playbooks': 'Success Playbooks',
  'menu.methodology-center.industry-templates': 'Industry Templates',
  'menu.methodology-center.analysis-logics': 'Analysis Logic Library',
  'menu.methodology-center.library-detail': 'Library Detail',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
